'use client';

import { createContext, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getThemeByUserType, themeColors as defaultTheme } from '../theme/theme';

const ThemeContext = createContext(defaultTheme);

export function ThemeContextProvider({ children }) {
  const userType = useSelector((state) => state.auth?.userType);

  const themeColors = useMemo(() => {
    return getThemeByUserType(userType);
  }, [userType]);

  return <ThemeContext.Provider value={themeColors}>{children}</ThemeContext.Provider>;
}

// Custom hook to use theme colors
export function useThemeColors() {
  const context = useContext(ThemeContext);
  if (!context) {
    // Return default theme if not in provider
    return defaultTheme;
  }
  return context;
}

export default ThemeContext;
